




























import Vue from 'vue';
import { mapGetters } from 'vuex';
import { Record } from '@/types/Record';

export default Vue.extend({
    name: 'TextInstruction',
    props: ['instruction', 'video'],
    data() {
        return {
            dialog: false,
            value: '',
        };
    },
    computed: {
        ...mapGetters(['records']),
        record(): Record | undefined {
            return this.records.find((record: Record) => record.instruction_id === this.instruction.id && record.video_id === this.video.id);
        },
    },
    methods: {
        async submit() {
            const result = await this.$store.dispatch('uploadRecord', {
                value: this.value,
                instruction: this.instruction,
                video: this.video,
                record: this.record,
            });

            if (result) {
                this.$emit('next');
            }
        },
    },
    mounted(): void {
        if (this.record) {
            this.value = this.record.value as string;
        }
    },
});
